import ManualPagination from './ManualPagination';

export default ManualPagination;
